<div class="vtr-widget-card-hardware-scan-support-card">
	<div class="container-fluid">
		<a	[tabindex]="isOnline ? 0 : -1"
			class="col card-link"
			role="link"
			(keydown.enter)="linkClicked()"
			(click)="linkClicked()"
			rel="noopener"
			[matTooltip]= "tooltipText | translate | htmlText"
			matTooltipClass="vtr-system-tooltip"
			id="{{ widgetId }}_side_article">
		</a>

		<div class="row card-content">
			<div class="wrapper-title">
				<h2 id="{{ widgetId }}-title"
				role="heading"
				class="title">
				{{ title | translate }}
				</h2>
			</div>
			<div class="wrapper-image">
				<img class="card-image"
					[alt]="title | translate"
				src="assets/images/support-card.png" />
			</div>
			<div class="wrapper-description">
				<span id="{{ widgetId }}-description"
				role="text"
				class="description">
				{{ description | translate }}
				</span>
			</div>

		<div *ngIf="!isOnline"
			class="row offline-icon col col-12"
			id="{{ widgetId }}-offline-icon"
			aria-labelledby="offline-icon-message">
			<fa-icon [icon]="['fal', 'wifi-slash']"
				aria-label="offline icon, image"
				a11yRole="text"></fa-icon>
			<div class="offline-message"
				id="offline-icon-message"
				role="text"
				aria-hidden="true">
				{{ 'hardwareScan.support.connectToUseFeature' | translate }}
			</div>
		</div>
	</div>
</div>
